export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11764.dd1c342d.jpg";